// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"5c8c703c","107":"22a0cb96","199":"0c036ffb","316":"5bc88bad","794":"e5e74e69"}[chunkId] + ".chunk.js";
};